export enum adminScoutsDetailTypes {
    FETCH_ADMIN_SCOUTS_DETAIL_REQUEST = "FETCH_ADMIN_SCOUTS_DETAIL_REQUEST",
    FETCH_ADMIN_SCOUTS_DETAIL_SUCCESS = "FETCH_ADMIN_SCOUTS_DETAIL_SUCCESS",
    FETCH_ADMIN_SCOUTS_DETAIL_FAILURE = "FETCH_ADMIN_SCOUTS_DETAIL_FAILURE",
  }